__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "contact-experience-portal";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@aws-amplify/api", "5.4.26", () => (Promise.all([__webpack_require__.e(8467), __webpack_require__.e(485), __webpack_require__.e(9324), __webpack_require__.e(5682)]).then(() => (() => (__webpack_require__(90485))))));
			register("@mui/material", "5.18.0", () => (Promise.all([__webpack_require__.e(1756), __webpack_require__.e(5904), __webpack_require__.e(4914), __webpack_require__.e(6672)]).then(() => (() => (__webpack_require__(51756))))));
			register("@mui/x-license", "7.29.1", () => (Promise.all([__webpack_require__.e(4914), __webpack_require__.e(8440)]).then(() => (() => (__webpack_require__(48440))))));
			register("@reduxjs/toolkit", "1.9.7", () => (Promise.all([__webpack_require__.e(5614), __webpack_require__.e(6902)]).then(() => (() => (__webpack_require__(28138))))));
			register("amazon-connect-streams", "2.30.1", () => (__webpack_require__.e(4726).then(() => (() => (__webpack_require__(44726))))));
			register("aws-appsync", "4.1.10", () => (Promise.all([__webpack_require__.e(8467), __webpack_require__.e(425), __webpack_require__.e(5614), __webpack_require__.e(9087), __webpack_require__.e(1485)]).then(() => (() => (__webpack_require__(79087))))));
			register("graphql-tag", "2.12.7", () => (Promise.all([__webpack_require__.e(425), __webpack_require__.e(1057)]).then(() => (() => (__webpack_require__(11057))))));
			register("jwt-decode", "3.1.2", () => (__webpack_require__.e(6765).then(() => (() => (__webpack_require__(6765))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-draggable", "4.5.0", () => (Promise.all([__webpack_require__.e(5794), __webpack_require__.e(4914), __webpack_require__.e(6672)]).then(() => (() => (__webpack_require__(55794))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(8502), __webpack_require__.e(4914), __webpack_require__.e(6672)]).then(() => (() => (__webpack_require__(38502))))));
			register("react", "18.3.1", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(4914), __webpack_require__.e(8094)]).then(() => (() => (__webpack_require__(78094))))));
			register("superagent", "8.1.2", () => (Promise.all([__webpack_require__.e(5734), __webpack_require__.e(3730)]).then(() => (() => (__webpack_require__(15734))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};